import { render, staticRenderFns } from "./ReplyUserMentions.vue?vue&type=template&id=aab8b202"
import script from "./ReplyUserMentions.vue?vue&type=script&lang=js"
export * from "./ReplyUserMentions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports